<!-- 客诉工单 -->
<template>
    <div id="workOrder">

        <custom-table has-organization="true" ref="customTable" :customOptions="customOptions" :columns="columns"
            :columnsSettingShow="true">
            <template slot="table-operation">
                <el-table-column label="操作" width="100" fixed="right" align="center">
                    <div slot-scope="{ row }" class="custom-action">
                        <el-button type="text" @click="detailFn(row)">详情</el-button>
                    </div>
                </el-table-column>
            </template>

            <template slot-scope="{ item, row }">
                <template v-if="['created', 'updated'].includes(item.prop)">
                    {{ row[item.prop] | filterTime }}
                </template>
                <template v-else-if="item.prop == 'status'">
                    <el-tag :type="row.status | filterConst('WORKORDERSTATUS', 'type')">{{ row.status | filterConst('WORKORDERSTATUS') }}</el-tag>
                </template>
                <template v-else-if="item.prop == 'priority'">
                    <span v-for="item in $const.URGENCYLIST.filter(item => item.value == row.priority)" :key="item.value" :style="{color: item.color}">{{ item.label }}</span>
                </template>
                <template v-else-if="item.prop == 'channelAlias'">
                    <span>{{ row.channelAlias | filterConst('HITCHHIKINGCHANNEL') }}</span>
                </template>
                <template v-else-if="item.prop == 'orderNo'">
                    <div>自有：{{ row.orderNo }}<el-button type="text" @click="$utils.copyText(row.orderNo)" class="ml-5">复制</el-button></div>
                    <div>{{ row.channelAlias | filterConst('HITCHHIKINGCHANNEL') }}：{{ row.partnerOrderId }}<el-button class="ml-5" type="text" @click="$utils.copyText(row.partnerOrderId)">复制</el-button></div>
                </template>
                <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
            </template>
        </custom-table>
    </div>
</template>

<script>
    export default {
        name: "workOrder",
        components: {},
        data() {
            return {
                customOptions:  {
                    // 请求的列表url
                    url: "/api/v1/manage/hitchRide/work",
                    // 请求的参数列表
                    params: {
                        page: 1, // 页数
                        size: 20, // 每页条数
                    },
                    search: [
                        { type: "input", field: "workNo", name: "工单编号", value: "" },
                        { type: "input", field: "orderNo", name: "自有订单号", value: "" },
                        { type: "input", field: "partnerOrderId", name: "三方订单号", value: "" },
                        {
                            type: "select",
                            field: "priority",
                            name: "紧急程度",
                            value: "",
                            option: this.$const.URGENCYLIST,
                        },
                        {
                            type: "cascader",
                            field: "categoryId",
                            name: "客诉类型",
                            value: "",
                            option: this.workTypeList,
                            props: {
                                value: 'id',
                                label: 'name',
                                children: 'children'
                            },
                        },
                    ],
                },
                
                // 表头
                columns: [
                    { prop: "workNo", label: "工单编号", width: 130 },
                    { prop: "status", label: "状态", width: 70 },
                    { prop: "priority", label: "紧急程度", width: 80 },
                    { prop: "channelAlias", label: "来源", width: 80 },
                    { prop: "orderNo", label: "订单号", minWidth: 320 },
                    { prop: "categoryName", label: "客诉类型", minWidth: 200 },
                    { prop: "created", label: "创建时间", width: 140 },
                    { prop: "updated", label: "更新时间", width: 140 },
                ],
            };
        },
        computed: {
            // // 配置项
            // customOptions() {
            //     return
            // }
        },
        async created() {
            await this.mixinGetWorkType();
            let index = this.customOptions.search.findIndex(item => item.field == 'categoryId');
            this.customOptions.search[index].option = this.workTypeList;
        },

        methods: {
            detailFn(row) {
                this.$router.push({
                    path: '/hitchRideWorkDetail',
                    query: {
                        id: row.id
                    }
                })
            }
        },
    };
</script>

<style scoped lang="less">

</style>